const ABWEICHENDER_VERTRAGSINHABER_HELPER_TEXT =
  'Bitte so eintragen, wie es später im Vertrag erscheinen soll – z. B. "Herr Max Mustermann" oder "Firma RITA AG".';

export default ABWEICHENDER_VERTRAGSINHABER_HELPER_TEXT;
